module.exports = __webpack_public_path__ + "static/img/banner-yingyin.afb5d6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner-yingyin.jpg
// module id = ruC2
// module chunks = 0